import React, { lazy } from 'react';
import { Check, ShieldCheck, Zap, Lock } from 'lucide-react';
export function PricingSection() {
  return <section className="bg-[#FFFFFF] py-20 px-4" data-id="element-104">
      <div className="max-w-3xl mx-auto relative" data-id="element-105">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-106">
          <div className="inline-block bg-[#E91E63] text-white font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-107">
            ⏰ Oferta por Tiempo Limitado
          </div>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border-2 border-[#00BCD4] p-8 md:p-12 text-center relative overflow-hidden mt-4" data-id="element-108">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-[#00BCD4]/10 to-transparent rounded-bl-full -z-10" data-id="element-109"></div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-8 mt-4" data-id="element-110">
            Accedé hoy al MegaPack Completo
          </h2>

          <div className="mb-8 flex justify-center" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/tA8mu5NGJHgzqLES6uPFdY/ChatGPT_Image_8_mar_2026,_05_35_05_p.m..png" alt="Mega Pack de Intensificación" className="w-full max-w-md rounded-xl shadow-lg object-cover" width="448" height="672" loading="lazy" decoding="async" data-id="element-112" />
          </div>

          <div className="mb-2" data-id="element-113">
            <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-114">
              $39.999
            </span>
          </div>

          <div className="mb-4" data-id="element-115">
            <div className="inline-block bg-[#00BCD4] text-white font-black text-2xl px-6 py-2 rounded-xl mb-4 shadow-md transform -rotate-2" data-id="element-116">
              50% OFF
            </div>
          </div>

          <div className="mb-4" data-id="element-117">
            <span className="text-6xl md:text-7xl font-black text-[#1A1A1A] tracking-tight" data-id="element-118">
              $19.999
            </span>
          </div>

          <p className="text-gray-600 font-medium mb-10" data-id="element-119">
            Pago único. Acceso inmediato. Sin suscripción.
          </p>

          <div className="bg-gray-50 rounded-2xl p-6 mb-10 text-left" data-id="element-120">
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-121">
              <li className="flex items-center gap-3" data-id="element-122">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-123">
                  <Check className="w-4 h-4 text-green-600" data-id="element-124" />
                </div>
                <span className="text-[#1A1A1A] font-medium text-sm" data-id="element-125">
                  8 Materias Completas
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-126">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-127">
                  <Check className="w-4 h-4 text-green-600" data-id="element-128" />
                </div>
                <span className="text-[#1A1A1A] font-medium text-sm" data-id="element-129">
                  Instrumentos de Evaluación
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-130">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-131">
                  <Check className="w-4 h-4 text-green-600" data-id="element-132" />
                </div>
                <span className="text-[#1A1A1A] font-medium text-sm" data-id="element-133">
                  Guías de Actividades
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-134">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-135">
                  <Check className="w-4 h-4 text-green-600" data-id="element-136" />
                </div>
                <span className="text-[#1A1A1A] font-medium text-sm" data-id="element-137">
                  Documentación de Respaldo
                </span>
              </li>
              <li className="flex items-center gap-3 md:col-span-2 justify-center" data-id="element-138">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-139">
                  <Check className="w-4 h-4 text-green-600" data-id="element-140" />
                </div>
                <span className="text-[#1A1A1A] font-medium text-sm" data-id="element-141">
                  3 Bonos Especiales
                </span>
              </li>
            </ul>
          </div>

          <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9dBQQc9h2ha4bWIEiqNW5/es-ar" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#C0FF33] hover:bg-[#B0EF23] text-[#1A1A1A] font-black text-xl py-5 px-8 rounded-2xl shadow-xl shadow-lime-400/30 transition-all duration-300 transform hover:-translate-y-1 mb-4 text-center" data-id="element-142">
            ¡Quiero esta oferta! →
          </a>

          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mb-8" data-id="element-143">
            <Lock className="w-4 h-4" data-id="element-144" />
            <span data-id="element-145">Pago seguro con Mercado Pago</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-6 border-t border-gray-100" data-id="element-146">
            <div className="flex items-center gap-2 text-gray-600 font-medium" data-id="element-147">
              <ShieldCheck className="w-5 h-5 text-[#00BCD4]" data-id="element-148" />
              <span data-id="element-149">Garantía de 7 días</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600 font-medium" data-id="element-150">
              <Zap className="w-5 h-5 text-[#E91E63]" data-id="element-151" />
              <span data-id="element-152">Acceso inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}